(function() {
  var KEY = 'tas-entry-logo-played';
  var root = document.documentElement;

  function markPlayed() {
    try {
      sessionStorage.setItem(KEY, 'true');
    } catch (error) {}
  }

  function removeOverlay() {
    var overlay = document.getElementById('TasEntryLogo');
    if (overlay) overlay.remove();
  }

  function finish(shouldMarkPlayed) {
    if (shouldMarkPlayed !== false) markPlayed();

    root.classList.add('tas-entry-complete');
    root.classList.remove('tas-entry-pending', 'tas-entry-moving', 'tas-entry-reveal');

    requestAnimationFrame(removeOverlay);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function() {
    if (window.Shopify && Shopify.designMode) {
      finish(false);
      return;
    }

    if (!root.classList.contains('tas-entry-pending')) {
      removeOverlay();
      return;
    }

    var overlay = document.getElementById('TasEntryLogo');
    var movingLogo = overlay ? overlay.querySelector('.tas-entry-logo__inner') : null;
    var targetLogo = document.querySelector('.header__heading-logo');

    if (!overlay || !movingLogo || !targetLogo) {
      finish(true);
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish(true);
      return;
    }

    function animateLogo() {
      var start = movingLogo.getBoundingClientRect();
      var target = targetLogo.getBoundingClientRect();

      if (!start.width || !target.width) {
        finish(true);
        return;
      }

      var startCenterX = start.left + start.width / 2;
      var startCenterY = start.top + start.height / 2;
      var targetCenterX = target.left + target.width / 2;
      var targetCenterY = target.top + target.height / 2;
      var translateX = targetCenterX - startCenterX;
      var translateY = targetCenterY - startCenterY;
      var scale = target.width / start.width;

      markPlayed();
      root.classList.add('tas-entry-moving');
      window.setTimeout(function() {
        root.classList.add('tas-entry-reveal');
      }, 180);

      var animation = movingLogo.animate(
        [
          { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 },
          { transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0) scale(' + scale + ')', opacity: 1 }
        ],
        {
          duration: 980,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'forwards'
        }
      );

      animation.finished.then(function() {
        finish(false);
      }).catch(function() {
        finish(false);
      });
    }

    requestAnimationFrame(function() {
      window.setTimeout(animateLogo, 850);
    });

    window.setTimeout(function() {
      if (root.classList.contains('tas-entry-pending')) {
        finish(true);
      }
    }, 3600);
  });
})();
